import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { JPMAM_TASK_BASE_PATH } from '../../../../../../../../../features/vendor/jpmam/task/jpmam-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/jpm/task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'jpmam-task-list',
        label: 'J.P. Morgan',
        to: JPMAM_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
